export default "query salutations{\n    salutations\n}";